/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { IconButton, ParagraphWithTooltip } from 'components';
import { DraggIcon } from 'assets/icons';

export const Item = ({ provided, fieldNameToHeaderName, item, sectionName }) => {
  return (
    <DraggableItem
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      style={{ ...provided.draggableProps.style }}
    >
      <ParagraphWithTooltip text={fieldNameToHeaderName[sectionName][item]} />
      <IconButton.SmallSize
        onClick={() => {}}
        icon={DraggIcon}
        type={IconButton.btnTypes.tertiary}
        isDefaultMuted
      />
    </DraggableItem>
  );
};

const DraggableItem = styled.div`
  background: white;
  height: 32px;
  color: ${Palette.PrimaryGray._700};
  display: flex;
  padding-left: 8px;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  border-radius: 4px;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
  border: 1px solid ${Palette.PrimaryGray._200};
  margin-bottom: 4px;
`;
